/* eslint-disable no-underscore-dangle */
export default class ContextHelper {

    static assign(context) {

        context.getStorages = () => {

            if (context._storages == undefined) {

                const fromStringToStorage = (text) => {

                    const values = String(text).split(':');

                    return [values[0], { className: values[0], id: values[1] }];
                };

                context._storages = (Array.isArray(context.storages))
                    ? Object.fromEntries(context.storages.map((text) => fromStringToStorage(text)))
                    : Object.fromEntries([fromStringToStorage(context.storages)]);
            }

            return context._storages;
        };

        context.getDefaultStorage = () => {

            if (context._defaultStorage == undefined) {

                const storages = context.getStorages();
                context._defaultStorage = storages[Object.keys(storages)[0]];
            }

            return context._defaultStorage;
        };

        context.getStorage = (name) => context.getStorages()[name];

        return context;
    }

}